import React, { useState } from 'react';
import { TwitterTimelineEmbed } from 'react-twitter-embed';

import Loading from '../../core/Loading';
import { StyledWrapper } from './style';

const Twitter = () => {
  const [loading, setLoading] = useState(true);

  const onLoaded = () => {
    setLoading(false);
  };

  return (
    <StyledWrapper>
      {loading && <Loading />}
      <TwitterTimelineEmbed
        sourceType="profile"
        screenName="atresmediacom"
        noHeader="true"
        noFooter="true"
        noBorders="true"
        onLoad={onLoaded}
        lang="es"
        options={{ height: 500, width: 550 }}
      />
    </StyledWrapper>
  );
};

export default Twitter;
